import { useEffect } from 'react';
import { OrderList } from '../../components/orders/order-list';
import { Seo } from '../../components/seo';
import { useUIStore } from '../../store/ui-store';

function OrdersListPage() {
  const { setTitle, setBreadcrumbs } = useUIStore();

  useEffect(() => {
    setBreadcrumbs([]);
    setTitle('Manage Orders');
  }, [setBreadcrumbs, setTitle]);

  return (
    <>
      <Seo title="Manage Orders" />
      <div className="px-12 pt-10 pb-[35px]">
        <OrderList />
      </div>
    </>
  );
}

export default OrdersListPage;
